import { AES, enc } from 'crypto-js';

import config from '../config';

export default class StorageHelper {
  static KEYS = {
    USER: 'user',
    CONTEXT: 'context',
    TOKEN_USUARIO: 'token-usuario',
    TOKEN_API_V2: 'token-api-v2',
    TOKEN_SISTEMA: 'token-sistema',
  };

  static getMeta(key) {
    const item = window.localStorage.getItem(`${config.appKey}-${key}`);

    if (item) {
      try {
        const decrypted = AES.decrypt(item, config.storageSecret).toString(enc.Utf8);
        return JSON.parse(decrypted);
      } catch (e) {}
    }

    return false;
  }

  static getItem(key, def = null) {
    const item = window.localStorage.getItem(`${config.appKey}-${key}`);

    if (item) {
      try {
        const decrypted = AES.decrypt(item, config.storageSecret).toString(enc.Utf8);
        return JSON.parse(decrypted).value;
      } catch (e) {}
    }

    return def;
  }

  static setItem(key, value) {
    key = `${config.appKey}-${key}`;

    const item = {
      key,
      value,
      created: new Date().toISOString(),
    };

    const encrypted = AES.encrypt(JSON.stringify(item), config.storageSecret).toString();
    return window.localStorage.setItem(key, encrypted);
  }

  static removeItem(key) {
    return window.localStorage.removeItem(`${config.appKey}-${key}`);
  }

  static clear() {
    return window.localStorage.clear();
  }

  static getUser() {
    return this.getItem(this.KEYS.USER);
  }

  static getContext() {
    return this.getItem(this.KEYS.CONTEXT);
  }

  static getTokenUsuario() {
    return this.getItem(this.KEYS.TOKEN_USUARIO);
  }

  static getTokenApiV2() {
    return this.getItem(this.KEYS.TOKEN_API_V2);
  }

  static getTokenSistema() {
    return this.getItem(this.KEYS.TOKEN_SISTEMA);
  }
}
